import React from "react";
import {
  Box,
  Heading,
  SimpleGrid,
  Stack,
  Text,
  Input,
  HStack,
  Button,
} from "@chakra-ui/react";

export default function ConnectWalletForm() {
  return (
    <Stack my={20} maxW="1300px">
      <Heading
        fontWeight={"semibold"}
        fontSize={{ base: "21px", lg: "30px" }}
        pb={10}
      >
        Connect Wallet
      </Heading>
      <Box border="1px solid #c5c5c5" borderRadius={10}>
        <Stack gap={5} p={10}>
          <SimpleGrid columns={{ base: 1, md: 2 }} gap={10}>
            <Box>
              <Text
                fontSize={{ base: "18px", lg: "26px" }}
                fontWeight="semibold"
              >
                First Name
              </Text>
              <Input placeholder="John" size="sm" py={6} mt={2} />
            </Box>
            <Box>
              <Text
                fontSize={{ base: "18px", lg: "26px" }}
                fontWeight="semibold"
              >
                Last Name
              </Text>
              <Input placeholder="Abraham" size="sm" py={6} mt={2} />
            </Box>
            <Box>
              <Text
                fontSize={{ base: "18px", lg: "26px" }}
                fontWeight="semibold"
              >
                Country
              </Text>
              <Input placeholder="John" size="sm" py={6} mt={2} />
            </Box>
            <Box>
              <Text
                fontSize={{ base: "18px", lg: "26px" }}
                fontWeight="semibold"
              >
                City
              </Text>
              <Input placeholder="Multan" size="sm" py={6} mt={2} />
            </Box>
          </SimpleGrid>
          <Box>
            <Text fontSize={{ base: "18px", lg: "26px" }} fontWeight="semibold">
              Address
            </Text>
            <Input placeholder="Street Address" size="sm" py={6} mt={2} />
            <Input
              placeholder="Street Address Line 2 (Optional)"
              size="sm"
              py={6}
              mt={2}
            />
          </Box>
          <Box>
            <Text fontSize={{ base: "18px", lg: "26px" }} fontWeight="semibold">
              Postal Code (Optional)
            </Text>
            <Input
              placeholder="62450"
              size="md"
              py={6}
              mt={2}
              w={{ md: "50%" }}
            />
          </Box>
        </Stack>
        <HStack
          justifyContent="end"
          borderTop={"1px"}
          py={5}
          px={10}
          borderColor="#c5c5c5"
        >
          <Button
            bg="brand.500"
            borderRadius={10}
            color="white"
            px={10}
            py={6}
            _hover={{ bg: "brand.400", color: "white" }}
          >
            Connect Wallet
          </Button>
        </HStack>
      </Box>
    </Stack>
  );
}
